// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2irbb","colBig":"styles_colBig__1SaqA","colSmall":"styles_colSmall__3CFky","shopifyNameWrapper":"styles_shopifyNameWrapper__dIKU7"};